<template>
  <div class="main-container">
      <div class="main-container__row vesting-form-section__row">
        <div class="main-container__column main-container__column_8 vesting-form-section__column">
          <form class="vesting-form" id="vesting-form">
            <h2 class="vesting-form-section__title font-semibold font-body font-lr-body-text">
              {{$t('Проверка статуса вестинга')}}
            </h2>
            <div class="vesting-form-section__content">
              <div v-if="isConnected" class="vesting-form-section__badges">
                <div v-if="isCorrectNetwork" class="vesting-form-section__badge vesting-form-section__badge_bep20">
                  <img src="../assets/icons/bep-20.svg" width="24" height="24" alt="bep-20 icon"/>
                  <p class="font-body-text-small font-semibold">BEP-20</p>
                </div>
                <div  class="vesting-form-section__badge vesting-form-section__badge_metamask">
                  <img src="../assets/icons/metamask.svg" width="24" height="24" alt="metamask icon"/>
                  <p class="font-body-text-small font-semibold">
                    {{ abbreviatedWalletAddress }}
                  </p>
                  <button
                    @click="disconnectWallet"
                    class="vesting-form-section__close-badge tooltip"
                    type="button"
                  >
                    <img
                      class="vesting-form-section__close-badge_icon"
                      src="../assets/icons/x-close.svg"
                      alt="disconnect metamask button icon"
                    />
                    <span class="tooltip-text font-semibold font-body-text-small">
                      {{$t('Отключить кошелек')}}
                    </span>
                  </button>
                </div>
              </div>

              <div class="vesting-form-section__description font-normal font-color-main-body font-title font-lr-body-text">
                <p class="vesting-form-section__paragraph_title">
                  {{$t('Доступный баланс')}}
                </p>
                <p class="vesting-form-section__paragraph_description font-title font-lr-body-text font-medium font-color-text">
                  {{ vestingSummaryBalanceFormatted }}
                </p>
              </div>
              <div class="vesting-form-section__description font-normal font-color-main-body font-title font-lr-body-text">
                <p class="vesting-form-section__paragraph_title">
                  {{$t('Разблокированная сумма')}}
                </p>
                <p class="vesting-form-section__paragraph_description font-title font-lr-body-text font-medium font-color-text">
                  {{ vestingSummaryUnlockedFormatted }}
                </p>
              </div>
              <div class="vesting-form-section__description font-normal font-color-main-body font-title font-lr-body-text">
                <p class="vesting-form-section__paragraph_title">
                  {{$t('Заблокированная сумма')}}
                </p>
                <p class="vesting-form-section__paragraph_description font-title font-lr-body-text font-medium font-color-text">
                  {{ vestingSummaryLockedFormatted }}
                </p>
              </div>
              <!-- <div class="vesting-form-section__description font-normal font-color-main-body font-title font-lr-body-text">
                <p class="vesting-form-section__paragraph_title">
                  {{$t('Дата следующей разблокировки')}}
                </p>
                <p class="vesting-form-section__paragraph_description font-title font-lr-body-text font-medium font-color-text">
                  {{ nextUnlockDate }}
                </p>
              </div>
              <div class="vesting-form-section__description vesting-form-section__description_last font-normal font-color-main-body font-title font-lr-body-text">
                <p class="vesting-form-section__paragraph_title">
                  {{$t('Время до следующей разблокировки')}}
                </p>
                <p class="vesting-form-section__paragraph_description font-title font-lr-body-text font-medium font-color-text">
                  {{ nextUnlockDaysDifference }} {{isConnected ? $t('дней') : ""}}
                </p>
              </div> -->

              <div
                v-if="vestingsList && vestingsList.length"
                class="vesting-form-section__participation"
              >
                <h2 class="vesting-form-section__participation-title font-semibold font-body font-lr-body-text">
                  {{$t('Участие в вестингах')}}
                </h2>
                <div
                  v-for="vesting in vestingsList"
                  :key="vesting.amount_vesting_lock * Math.random()"
                  class="vesting-form-section__participation-description font-body-text"
                >
                  <div class="vesting-form-section__participation-paragraph">
                    <p class="vesting-form-section__participation-label font-normal font-color-main-body">
                      {{$t('Вестинг')}}
                    </p>
                    <div class="vesting-form-section__participation-value vesting-form-section__participation-value_hash font-medium font-color-text">
                      <p class="vesting-form-section__hash">
                        {{ vesting.vesting?.address }}
                      </p>
                      <img
                      id="copy-btn"
                      src="../assets/icons/copy.svg"
                      @click="() => copyToClipboard(vesting.vesting?.address)"
                      class="vesting-form-section__copy-btn copy"
                      alt="copy button icon"
                      width="28"
                      height="28"
                      />
                    </div>
                  </div>
                  <div class="vesting-form-section__participation-paragraph">
                    <p class="vesting-form-section__participation-label font-normal font-color-main-body">
                      {{$t('Разблокированная сумма')}}
                    </p>
                    <p class="vesting-form-section__participation-value font-medium font-color-text">
                      {{ vesting.amount_unlock }} NYS
                    </p>
                  </div>
                  <div class="vesting-form-section__participation-paragraph">
                    <p class="vesting-form-section__participation-label font-normal font-color-main-body">
                      {{$t('Заблокированная сумма')}}
                    </p>
                    <p class="vesting-form-section__participation-value font-medium font-color-text">
                      {{ vesting.amount_vesting_lock }} NYS
                    </p>
                  </div>
                </div>
              </div>
              

              
            </div>
            <div class="vesting-form-section____btn-block">
              
              <button
                v-if="isConnected"
                type="button"
                class="vesting-form-section____btn contact-form-section__submit buttons-block__btn buttons-block__btn_first buttons-block__btn_colored font-body-text font-semibold font-color-main-lighter ta-c font-lr-body-text"
                @click="disconnectWallet"
              >
                {{ $t("Отключить кошелек") }}
              </button>
              <button
                v-else
                type="button"
                class="vesting-form-section____btn contact-form-section__submit buttons-block__btn buttons-block__btn_first buttons-block__btn_colored font-body-text font-semibold font-color-main-lighter ta-c font-lr-body-text"
                @click="connectWallet"
              >
                {{ $t("Подключить кошелек") }}
              </button>
            </div>
          </form>
        </div>
      </div>
      <WarnSnackbar v-if="showSnackbar" :info="{text: $t('Вы подключены к неправильной сети. Пожалуйста, переключитесь на поддерживаемую сеть.'), type: warnTypes.regular}" :btn-name="'Switch'" :callback="changeNetworkToCorrect" />
    </div>
</template>

<script>
/* eslint-disable */
import BigNumber from "bignumber.js";
import warnTypes from "@/constants/WARN_TYPES.js"
import CONFIG_VARIABLES from "@/constants/CONFIG_VARIABLES.js"
import WarnSnackbar from "@/components/WarnSnackbar.vue";
import { modal } from "@/factories/web3/Web3Modal"
import { useSwitchNetwork, useWeb3ModalAccount, useWeb3ModalProvider } from "@web3modal/ethers/vue";
import { BrowserProvider, Contract, formatEther } from "ethers";
import moment from "moment-mini";

export default {
  name: "VestingForm",
  components: { WarnSnackbar },
  data() {
    return {
      warnTypes,
      CONFIG_VARIABLES,
      isConnected: null,
      walletAddress: null,
      walletProvider: null,
      currentChainID: null,
      maximumAmount: null,
      minimumAmount: null,
      userBalance: null,
      initLoading: false,
      transactionError: "",
      tokenPrice: "",
      transactionHash: "",
      currentExplorerUrl: CONFIG_VARIABLES.CORRECT_NETWORK_EXPLORER_URL,
      commonError: "",
      vestingsList: [],
      unlockDateConst: 10,
    };
  },
  created() {
    this.modal = modal;
    const { isConnected, chainId, address } = useWeb3ModalAccount();
    this.isConnected = isConnected;
    this.walletAddress = address;
    this.currentChainID = chainId;
  },
  computed: {
    isCorrectNetwork() {
      return this.currentChainID && this.currentChainID === CONFIG_VARIABLES.CORRECT_NETWORK_ID;
    },

    vestingSummaryBalanceFormatted() {
      return this.vestingSummaryBalance ? `${this.vestingSummaryBalance} NYS` : "-"
    },

    vestingSummaryUnlockedFormatted() {
      return this.vestingSummaryUnlocked ? `${this.vestingSummaryUnlocked} NYS` : "-"
    },

    vestingSummaryLockedFormatted() {
      return this.vestingSummaryLocked ? `${this.vestingSummaryLocked} NYS` : "-"
    },

    abbreviatedWalletAddress() {
      if (window.innerWidth <= 766) {
        return this.abbreviatedWalletAddressMobile;
      } else {
        return this.abbreviatedWalletAddressDesktop;
      }
    },

    abbreviatedWalletAddressDesktop() {
      return (
        this.walletAddress.substr(0, 6) +
        "..." +
        this.walletAddress.substr(
          this.walletAddress.length - 4,
          this.walletAddress.length
        )
      );
    },

    abbreviatedWalletAddressMobile() {
      return (
        "..." +
        this.walletAddress.substr(
          this.walletAddress.length - 4,
          this.walletAddress.length
        )
      );
    },

    userBalanceFormatted() {
      return this.isConnected ? this.userBalance : "-";
    },

    vestingSummaryUnlocked() {
      if (this.vestingsList.length) {
        const totalAmountVestingLock = this.vestingsList.reduce((sum, item) => {
          return sum + parseFloat(item.amount_unlock);
        }, 0);
        return totalAmountVestingLock
      }
    },

    vestingSummaryLocked() {
      if (this.vestingsList.length) {
        const totalAmountVestingLock = this.vestingsList.reduce((sum, item) => {
          return sum + parseFloat(item.amount_vesting_lock);
        }, 0);
        return totalAmountVestingLock
      }
    },

    vestingSummaryBalance() {
      if (this.vestingsList.length) {
        const totalAmountVestingBalance = this.vestingsList.reduce((sum, item) => {
          return sum + parseFloat(item.balance);
        }, 0);
        return totalAmountVestingBalance
      }
    },

    nextUnlockDate() {
      if (this.isConnected) {
        const now = new Date();
        const today = new Date(now.toISOString());
        const year = today.getFullYear();
        const month = today.getMonth();
        const day = today.getDate();
        let nextUnlock;
        if (day < this.unlockDateConst) {
          nextUnlock = new Date(year, month, this.unlockDateConst);
        } else {
          if (month === 11) {
            nextUnlock = new Date(year + 1, 0, this.unlockDateConst);
          } else {
            nextUnlock = new Date(year, month + 1, this.unlockDateConst);
          }
        }

        return `${moment(nextUnlock).format("DD.MM.YYYY")} (UTC)`;
      } else {
        return "-"
      }
    },

    nextUnlockDaysDifference() {
      if (this.isConnected) {
        const targetDate = moment.utc(this.nextUnlockDate, 'DD.MM.YYYY'); // Целевая дата в UTC
        const currentDate = moment.utc(); // Текущая дата в UTC
        return targetDate.diff(currentDate, 'days'); // Разница в днях
      } else {
        return "-"
      }
    }
  },
  watch: {
    isConnected(newVal) {
      if (newVal) {
        if (this.isCorrectNetwork) {
          this.showSnackbar = false;
        } else {
          this.showSnackbar = true;
        }
      } else {
        this.showSnackbar = false;
      }
    },
    isCorrectNetwork(newVal) {
      if (this.isConnected) {
        if (newVal) {
          this.showSnackbar = false;
        } else {
          this.showSnackbar = true;
        }
      }
    },
    walletAddress(newVal) {
      if (newVal && this.isConnected && this.isCorrectNetwork) {
        this.getVestingsInfo();
      }
    }
  },
  methods: {
    async getVestingsInfo() {
      try {
        this.isConnected = true;
        const userAddr = this.walletAddress;
        const origin = window.location.origin;
        const cookieToken = document.cookie.match(/csrftoken=[^\s;]+/);
        if (!cookieToken) {
          return;
        }
        const token = cookieToken[0].split("=")[1]
        const response = await fetch(origin + `/api/uservesting/${userAddr}`, {
          method: "GET",
          headers: {
            "X-CSRFToken": token,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          throw new Error(`Something went wrong: ${response.status}`);
        }

        const data = await response.json();
        console.log("vestings list data")
        console.log(data)
        this.vestingsList = data;

        // this.vestingsList = [
        //   {
        //     "vesting": {
        //       "address": "0x097F6024e08cEd22c42FF6D149E7173E41c605B9"
        //     },
        //     "user_address": "0x49939aeD5D127C2d9a056CA1aB9aDe9F79fa8E81",
        //     "balance": "14906462.973760932944606411",
        //     "amount_vesting_lock": "720.116618075801749269",
        //     "amount_unlock": "14905742.857142857142857142",
        //     "exclusion": true
        //   }
        // ]
      } catch (error) {
        console.error(error.message);
        return null;
      } finally {
        this.initLoading = false;
      }
    },
    connectWallet() {
      this.modal.open();
    },
    disconnectWallet() {
      this.modal.disconnect();
      this.vestingsList = [];
    },
    copyToClipboard(val) {
      navigator.clipboard.writeText(val);
      document.getElementById('copy-btn').classList.toggle("clicked");
      setTimeout(function () {
        document.getElementById('copy-btn').classList.remove("clicked");
      }, 1000);
    },
    async changeNetworkToCorrect() {
      this.initLoading = true;
      const { switchNetwork } = useSwitchNetwork();
      await switchNetwork(CONFIG_VARIABLES.CORRECT_NETWORK_ID);
      this.initLoading = false;
    },
  },
};
</script>

<style lang="scss">
.transaction-error {
  margin-top: 16px;
  color: #f76487;
  font-size: 14px;
  line-height: 20px;
  font-weight: 600;
  text-align: center;
}
</style>
